import React from "react";
import SimplePage from "../../shared/SimplePage";

export default function Terms() {
  return <SimplePage title="Terms of Service" />;
}
